import React from 'react';

const PackageIcon = () => {
  return <span className="material-icons">archive</span>;
};

export default PackageIcon;
